import { BuilderTypes } from "./BuilderTypes";

export class BuilderChangeDifferences {
    type: BuilderTypes;
    id: string;
    changeSetConfiguration: object;
    changeSetInitialConfiguration: object;
    mainConfiguration?: object;

    constructor(
        type: BuilderTypes,
        id: string,
        changeSetConfiguration: object,
        changeSetInitialConfiguration: object,
        mainConfiguration?: object
    ) {
        this.type = type;
        this.id = id;
        this.changeSetConfiguration = changeSetConfiguration;
        this.changeSetInitialConfiguration = changeSetInitialConfiguration;
        this.mainConfiguration = mainConfiguration;
    }
}
